var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("detail", {
        attrs: {
          prop: _vm.i18n.lbl_receiver(),
          value: _vm.tx.counterparty,
          copiable: true
        }
      }),
      _vm._v(" "),
      _c("detail", {
        attrs: {
          prop: _vm.i18n.lbl_amount(),
          value:
            _vm.i18n.c(_vm.tx.amount) +
            " " +
            _vm.formatTokenDisplay(_vm.tx.asset)
        }
      }),
      _vm._v(" "),
      _c("detail", {
        attrs: { prop: _vm.i18n.lbl_date(), value: _vm.tx.date }
      }),
      _vm._v(" "),
      _c("detail", {
        attrs: {
          prop: _vm.i18n.lbl_invoice_number(),
          value: _vm.tx.invoiceNumber
        }
      }),
      _vm._v(" "),
      _c("detail", { attrs: { prop: _vm.i18n.lbl_see_details_in_contract() } }),
      _vm._v(" "),
      _c("detail")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3c1e1230", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c1e1230","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/history/index/components/Details.Invoice.vue
// module id = EUbP
// module chunks = 1